import { ApiClient } from '../../client';
import {
  Grade,
  CreateGradeRequest,
  UpdateGradeRequest,
  GradeResponse,
  GradeQueryResponse,
  GradeQueryParams,
} from './types';
import { convertDatesToStrings } from '../../../../utils/dateConversion';

export class GradeService {
  constructor(private api: ApiClient) {}

  async getAll(params?: GradeQueryParams) {
    const queryParams = new URLSearchParams();
    if (params?.search) queryParams.append('search', params.search);
    if (params?.advancedSearch)
      queryParams.append(
        'advancedSearch',
        JSON.stringify(params.advancedSearch)
      );
    if (params?.sortBy) queryParams.append('sortBy', params.sortBy);
    if (params?.sortDirection)
      queryParams.append('sortDirection', params.sortDirection);
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.offset) queryParams.append('offset', params.offset.toString());

    const query = queryParams.toString();
    const url = `/grades${query ? `?${query}` : ''}`;
    return this.api.get<GradeQueryResponse>(url);
  }

  async getById(id: number) {
    return this.api.get<Grade>(`/grades/${id}`);
  }

  async create(data: CreateGradeRequest) {
    const payload = convertDatesToStrings(data);
    return this.api.post<GradeResponse>('/grades', payload);
  }

  async update(data: UpdateGradeRequest) {
    const payload = convertDatesToStrings(data);
    return this.api.put<GradeResponse>(`/grades/${data.grade_id}`, payload);
  }

  async delete(id: number) {
    return this.api.delete(`/grades/${id}`);
  }
}
